// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Design System Page Styles */
.design-system {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  background-color: var(--color-white);
}

/* Tablet: allow full width */
@media (max-width: 1024px) {
  .design-system {
    max-width: 100%;
    width: 100%;
    margin: 0;
  }
}

.design-system-header {
  text-align: center;
  margin-bottom: 40px;
  padding: 40px 0;
  border-bottom: 2px solid var(--color-light-gray);
}

.design-system-section {
  margin-bottom: 60px;
  padding: 30px;
  border: 1px solid var(--color-light-gray);
  border-radius: 8px;
  background-color: var(--color-white);
}

/* Component Grid Layouts */
.component-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-top: 20px;
}

.component-card {
  border: 1px solid var(--color-light-gray);
  border-radius: 6px;
  padding: 20px;
  background-color: var(--color-white);
  transition: all 0.2s ease;
}

.component-card:hover {
  box-shadow: var(--shadow-sm);
}

.component-preview {
  margin-bottom: 15px;
  padding: 15px;
  background-color: var(--color-light-gray);
  border-radius: 4px;
  min-height: 60px;
  display: flex;
  align-items: center;
}

.component-info {
  text-align: center;
}

/* Color Grid */
.color-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 15px;
  margin-top: 20px;
}

.color-card {
  border: 2px solid var(--color-light-gray);
  border-radius: 6px;
  padding: 15px;
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: var(--color-white);
}

.color-card:hover {
  border-color: var(--color-primary-green);
  transform: translateY(-2px);
}

.color-card.selected {
  border-color: var(--color-primary-green);
  box-shadow: var(--shadow-md);
}

.color-preview {
  width: 100%;
  height: 60px;
  border-radius: 4px;
  margin-bottom: 10px;
  border: 1px solid var(--color-light-gray);
}

.color-info {
  text-align: center;
}

.color-value {
  font-family: monospace;
  color: var(--color-gray);
}

.color-test-area {
  margin-top: 30px;
  padding: 20px;
  background-color: var(--color-light-gray);
  border-radius: 6px;
}

.color-test-content {
  margin-top: 15px;
}

.color-test-background {
  margin-top: 15px;
  padding: 15px;
  border-radius: 4px;
  min-height: 40px;
  display: flex;
  align-items: center;
}

/* Icon Grid */
.icon-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 15px;
  margin-top: 20px;
}

.icon-card {
  border: 2px solid var(--color-light-gray);
  border-radius: 6px;
  padding: 15px;
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: var(--color-white);
  text-align: center;
}

.icon-card:hover {
  border-color: var(--color-primary-green);
  transform: translateY(-2px);
}

.icon-card.selected {
  border-color: var(--color-primary-green);
  box-shadow: var(--shadow-md);
}

.icon-preview {
  margin-bottom: 10px;
  padding: 10px;
  background-color: var(--color-light-gray);
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 50px;
}

.icon-info {
  text-align: center;
}

.icon-test-area {
  margin-top: 30px;
  padding: 20px;
  background-color: var(--color-light-gray);
  border-radius: 6px;
}

.icon-test-content {
  margin-top: 15px;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.icon-size-test,
.icon-color-test {
  display: flex;
  align-items: center;
  gap: 10px;
}

/* Button Test Area */
.button-test-area {
  margin-top: 20px;
}

.button-variants,
.button-states,
.button-with-icons {
  margin-bottom: 30px;
  padding: 20px;
  background-color: var(--color-light-gray);
  border-radius: 6px;
}

.button-row {
  display: flex;
  gap: 15px;
  margin-top: 15px;
  flex-wrap: wrap;
}

/* Button Group Test Area */
.button-group-examples {
  margin-bottom: 30px;
  padding: 20px;
  background-color: var(--color-light-gray);
  border-radius: 6px;
}

.button-group-row {
  display: flex;
  gap: 30px;
  margin-top: 15px;
  flex-wrap: wrap;
  align-items: flex-start;
}

.button-group-demo {
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 200px;
}

.button-group-demo .button-group {
  align-self: flex-start;
}

/* Mobile responsive styles for ButtonGroup */
@media (max-width: 768px) {
  .button-group-row {
    flex-direction: column;
    gap: 20px;
  }
  
  .button-group-demo {
    min-width: auto;
    width: 100%;
  }
}

/* Toggle Test Area */
.toggle-test-area {
  margin-top: 20px;
}

.toggle-variants,
.toggle-interactive,
.toggle-typography {
  margin-bottom: 30px;
  padding: 20px;
  background-color: var(--color-light-gray);
  border-radius: 6px;
}

.toggle-row {
  display: flex;
  gap: 20px;
  margin-top: 15px;
  flex-wrap: wrap;
  align-items: center;
}

/* Checkbox Test Area */
.checkbox-test-area {
  margin-top: 20px;
}

.checkbox-variants,
.checkbox-interactive,
.checkbox-typography {
  margin-bottom: 30px;
  padding: 20px;
  background-color: var(--color-light-gray);
  border-radius: 6px;
}

.checkbox-row {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 15px;
}

.checkbox-group-example {
  margin-bottom: 30px;
  padding: 20px;
  background-color: var(--color-light-gray);
  border-radius: 6px;
}

.checkbox-group-section {
  margin-bottom: 25px;
}

.checkbox-group-section:last-child {
  margin-bottom: 0;
}

/* Radio Test Area */
.radio-test-area {
  margin-top: 20px;
}

.radio-variants,
.radio-interactive,
.radio-typography,
.radio-group-example {
  margin-bottom: 30px;
  padding: 20px;
  background-color: var(--color-light-gray);
  border-radius: 6px;
}

.radio-row {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 15px;
}

/* Chip Test Area */
.chip-test-area {
  margin-top: 20px;
}

.chip-examples,
.chip-states,
.chip-multi-select {
  margin-bottom: 30px;
  padding: 20px;
  background-color: var(--color-light-gray);
  border-radius: 6px;
}

.chip-row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 15px;
}

/* Tag Test Area */
.tag-test-area {
  margin-top: 20px;
}

.tag-examples,
.tag-categories,
.tag-ingredients,
.tag-concerns {
  margin-bottom: 30px;
  padding: 20px;
  background-color: var(--color-light-gray);
  border-radius: 6px;
}

.tag-row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 15px;
}

/* IconButton Test Area */
.iconbutton-test-area {
  margin-top: 20px;
}

.iconbutton-variants,
.iconbutton-sizes,
.iconbutton-states,
.iconbutton-examples {
  margin-bottom: 30px;
  padding: 20px;
  background-color: var(--color-light-gray);
  border-radius: 6px;
}

.iconbutton-row {
  display: flex;
  gap: 16px;
  margin-top: 15px;
  flex-wrap: wrap;
  align-items: center;
}

/* Card Test Area */
.card-test-area {
  margin-top: 20px;
}

.card-examples,
.card-variants,
.mobile-examples {
  margin-bottom: 40px;
}

.card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-top: 20px;
}

.routine-card-examples {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 20px;
  max-width: 1000px;
}

/* Mobile Preview Styles */
.mobile-preview {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.mobile-frame {
  width: 375px;
  height: 600px;
  border: 8px solid var(--surface-3);
  border-radius: 20px;
  background-color: var(--color-white);
  overflow: hidden;
  box-shadow: var(--shadow-md);
  position: relative;
}

.mobile-frame::before {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 4px;
  background-color: var(--surface-3);
  border-radius: 0 0 4px 4px;
}

.mobile-content {
  padding: 20px;
  height: 100%;
  overflow-y: auto;
  background-color: var(--color-light-gray);
}

.mobile-card-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.mobile-routine-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* Force mobile styles within mobile frame */
.mobile-frame .routine-card {
  width: 100% !important;
  padding: 12px !important;
  gap: 12px !important;
  border-radius: 8px !important;
}

.mobile-frame .routine-card-image {
  width: 64px !important;
  height: 64px !important;
}

.mobile-frame .routine-card-content {
  height: auto !important;
  justify-content: space-between !important;
  gap: 8px !important;
}

.mobile-frame .routine-card-texts {
  gap: 4px !important;
}

.mobile-frame .routine-card-name {
  font-size: 14px !important;
  line-height: 1.2 !important;
}

.mobile-frame .routine-card-company {
  font-size: 11px !important;
  line-height: 1.2 !important;
}

.mobile-frame .routine-card-drag-handle {
  display: none !important;
}

/* Force mobile styles for ProductCards within mobile frame */
.mobile-frame .product-card {
  width: 100% !important;
  height: auto !important;
  padding: 12px !important;
}

.mobile-frame .product-card-image {
  width: 64px !important;
  height: 64px !important;
}

.mobile-frame .product-card-bottom {
  gap: 6px !important;
  margin-top: 6px !important;
}

.mobile-frame .product-card-content p {
  font-size: 12px !important;
  line-height: 1.2 !important;
}

.mobile-frame .product-card-content h3 {
  font-size: 13px !important;
  line-height: 1.2 !important;
}

/* Force mobile styles for tags within mobile frame */
.mobile-frame .tag {
  padding: 0px 6px !important;
  border-radius: 3px !important;
}

.mobile-frame .tag .typography {
  font-size: 12px !important;
  line-height: 18px !important;
}

/* Responsive adjustments for mobile preview */
@media (max-width: 768px) {
  .mobile-frame {
    width: 320px;
    height: 500px;
  }
  
  .mobile-content {
    padding: 16px;
  }
  
  .mobile-card-grid {
    grid-template-columns: 1fr;
    gap: 10px;
  }
}

/* Popover Test Area */
.popover-test-area {
  margin-top: 20px;
}

.popover-examples,
.popover-variants,
.popover-options {
  margin-bottom: 30px;
  padding: 20px;
  background-color: var(--color-light-gray);
  border-radius: 6px;
}

.popover-edge-cases {
  margin-bottom: 30px;
  padding: 20px;
  background-color: var(--color-light-gray);
  border-radius: 6px;
  border: 2px dashed var(--color-primary-green);
}

.popover-row {
  display: flex;
  gap: 20px;
  margin-top: 15px;
  flex-wrap: wrap;
}

.popover-demo {
  position: relative;
  display: inline-block;
}

/* Dialog Test Area */
.dialog-test-area {
  margin-top: 20px;
}

.dialog-variants {
  margin-bottom: 30px;
  padding: 20px;
  background-color: var(--color-light-gray);
  border-radius: 6px;
}

.dialog-row {
  display: flex;
  gap: 15px;
  margin-top: 15px;
  flex-wrap: wrap;
}

/* Banner Test Area */
.banner-test-area {
  margin-top: 20px;
}

.banner-examples,
.banner-custom-titles,
.banner-long-content {
  margin-bottom: 30px;
  padding: 20px;
  background-color: var(--color-light-gray);
  border-radius: 6px;
}

/* TextInput Test Area */
.textinput-test-area {
  margin-top: 20px;
}

.textinput-examples {
  margin-bottom: 30px;
  padding: 20px;
  background-color: var(--color-light-gray);
  border-radius: 6px;
}

.textinput-examples .text-input-container {
  margin-bottom: 0;
}

/* Sidebar Test Area */
.sidebar-test-area {
  margin-top: 20px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
}

.sidebar-examples {
  padding: 20px;
  background-color: var(--color-light-gray);
  border-radius: 6px;
}

.sidebar-preview {
  border: 1px solid var(--color-gray);
  border-radius: 8px;
  background-color: var(--color-white);
  overflow: hidden;
}

.sidebar-info {
  padding: 20px;
  background-color: var(--color-light-gray);
  border-radius: 6px;
}

.sidebar-features {
  list-style: none;
  padding: 0;
  margin: 0;
}

.sidebar-features li {
  margin-bottom: 12px;
  padding-left: 20px;
  position: relative;
}

.sidebar-features li::before {
  content: "•";
  color: var(--color-primary-green);
  font-weight: bold;
  position: absolute;
  left: 0;
}

/* Responsive design for sidebar test area */
@media (max-width: 768px) {
  .sidebar-test-area {
    grid-template-columns: 1fr;
    gap: 20px;
  }
}

/* Interactive Tests */
.interactive-tests {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
  margin-top: 20px;
}

.test-card {
  border: 1px solid var(--color-light-gray);
  border-radius: 6px;
  padding: 20px;
  background-color: var(--color-white);
}

.interactive-icons,
.interactive-buttons {
  display: flex;
  gap: 15px;
  margin-top: 15px;
  flex-wrap: wrap;
}

/* Loading Spinner Test Area */
.loading-spinner-test-area {
  margin-top: 20px;
}

.loading-spinner-sizes,
.loading-spinner-with-text,
.loading-spinner-use-cases,
.loading-spinner-variants {
  margin-bottom: 30px;
  padding: 20px;
  background-color: var(--color-light-gray);
  border-radius: 6px;
}

.loading-spinner-row {
  display: flex;
  gap: 30px;
  margin-top: 15px;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: center;
}

.loading-spinner-demo {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  min-width: 150px;
}

.loading-spinner-examples {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-top: 15px;
}

.loading-spinner-example {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  padding: 20px;
  background-color: var(--color-white);
  border-radius: 6px;
  border: 1px solid var(--color-gray);
}

.loading-spinner-text-examples {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 15px;
  align-items: center;
}

/* Responsive Test */
.responsive-test {
  margin-top: 20px;
}

.responsive-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-top: 20px;
}

.responsive-item {
  border: 1px solid var(--color-light-gray);
  border-radius: 6px;
  padding: 20px;
  background-color: var(--color-light-gray);
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .design-system {
    padding: 16px;
  }
  
  .design-system-section {
    padding: 20px;
    margin-bottom: 40px;
  }
  
  .component-grid {
    grid-template-columns: 1fr;
  }
  
  .color-grid {
    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  }
  
  .icon-grid {
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  }
  
  .button-row {
    flex-direction: column;
  }
  
  .interactive-tests {
    grid-template-columns: 1fr;
  }
  
  .responsive-grid {
    grid-template-columns: 1fr;
  }
  
  .card-grid {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }
  
  .routine-card-examples {
    max-width: 100%;
  }
  
  .popover-row {
    flex-direction: column;
    gap: 16px;
  }
  
  .iconbutton-row {
    gap: 12px;
  }
  
  .loading-spinner-row {
    flex-direction: column;
    gap: 20px;
  }
  
  .loading-spinner-examples {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .design-system {
    padding: 16px;
  }
  
  .design-system-section {
    padding: 15px;
  }
  
  .color-grid {
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  }
  
  .icon-grid {
    grid-template-columns: repeat(auto-fit, minmax(80px, 1fr));
  }
} `, "",{"version":3,"sources":["webpack://./src/pages/DesignSystem.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,oCAAoC;AACtC;;AAEA,6BAA6B;AAC7B;EACE;IACE,eAAe;IACf,WAAW;IACX,SAAS;EACX;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;EAClB,aAAa;EACb,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,wCAAwC;EACxC,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,wCAAwC;EACxC,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,6CAA6C;AAC7C;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,WAAW;EACb;AACF;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;;AAEA;;;;EAIE,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;AAClB;;AAEA;;;;EAIE,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;AAClB;;AAEA;;;;EAIE,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kCAAkC;EAClC,mBAAmB;EACnB,oCAAoC;EACpC,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,WAAW;EACX,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,4CAA4C;AAC5C;EACE,sBAAsB;EACtB,wBAAwB;EACxB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,6DAA6D;AAC7D;EACE,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,qDAAqD;AACrD;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA,8CAA8C;AAC9C;EACE;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iCAAiC;EACjC,iBAAiB;EACjB,kBAAkB;EAClB,OAAO;AACT;;AAEA,4CAA4C;AAC5C;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;EAClB,aAAa;EACb,oCAAoC;AACtC;;AAEA;;EAEE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;AAClB;;AAEA;;;;EAIE,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,oCAAoC;EACpC,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;EAClB,aAAa;EACb,yCAAyC;AAC3C;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,2DAA2D;EAC7D;;EAEA;IACE,2DAA2D;EAC7D;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,2DAA2D;EAC7D;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,2DAA2D;EAC7D;;EAEA;IACE,0DAA0D;EAC5D;AACF","sourcesContent":["/* Design System Page Styles */\n.design-system {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 20px;\n  background-color: var(--color-white);\n}\n\n/* Tablet: allow full width */\n@media (max-width: 1024px) {\n  .design-system {\n    max-width: 100%;\n    width: 100%;\n    margin: 0;\n  }\n}\n\n.design-system-header {\n  text-align: center;\n  margin-bottom: 40px;\n  padding: 40px 0;\n  border-bottom: 2px solid var(--color-light-gray);\n}\n\n.design-system-section {\n  margin-bottom: 60px;\n  padding: 30px;\n  border: 1px solid var(--color-light-gray);\n  border-radius: 8px;\n  background-color: var(--color-white);\n}\n\n/* Component Grid Layouts */\n.component-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 20px;\n  margin-top: 20px;\n}\n\n.component-card {\n  border: 1px solid var(--color-light-gray);\n  border-radius: 6px;\n  padding: 20px;\n  background-color: var(--color-white);\n  transition: all 0.2s ease;\n}\n\n.component-card:hover {\n  box-shadow: var(--shadow-sm);\n}\n\n.component-preview {\n  margin-bottom: 15px;\n  padding: 15px;\n  background-color: var(--color-light-gray);\n  border-radius: 4px;\n  min-height: 60px;\n  display: flex;\n  align-items: center;\n}\n\n.component-info {\n  text-align: center;\n}\n\n/* Color Grid */\n.color-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 15px;\n  margin-top: 20px;\n}\n\n.color-card {\n  border: 2px solid var(--color-light-gray);\n  border-radius: 6px;\n  padding: 15px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  background-color: var(--color-white);\n}\n\n.color-card:hover {\n  border-color: var(--color-primary-green);\n  transform: translateY(-2px);\n}\n\n.color-card.selected {\n  border-color: var(--color-primary-green);\n  box-shadow: var(--shadow-md);\n}\n\n.color-preview {\n  width: 100%;\n  height: 60px;\n  border-radius: 4px;\n  margin-bottom: 10px;\n  border: 1px solid var(--color-light-gray);\n}\n\n.color-info {\n  text-align: center;\n}\n\n.color-value {\n  font-family: monospace;\n  color: var(--color-gray);\n}\n\n.color-test-area {\n  margin-top: 30px;\n  padding: 20px;\n  background-color: var(--color-light-gray);\n  border-radius: 6px;\n}\n\n.color-test-content {\n  margin-top: 15px;\n}\n\n.color-test-background {\n  margin-top: 15px;\n  padding: 15px;\n  border-radius: 4px;\n  min-height: 40px;\n  display: flex;\n  align-items: center;\n}\n\n/* Icon Grid */\n.icon-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));\n  gap: 15px;\n  margin-top: 20px;\n}\n\n.icon-card {\n  border: 2px solid var(--color-light-gray);\n  border-radius: 6px;\n  padding: 15px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  background-color: var(--color-white);\n  text-align: center;\n}\n\n.icon-card:hover {\n  border-color: var(--color-primary-green);\n  transform: translateY(-2px);\n}\n\n.icon-card.selected {\n  border-color: var(--color-primary-green);\n  box-shadow: var(--shadow-md);\n}\n\n.icon-preview {\n  margin-bottom: 10px;\n  padding: 10px;\n  background-color: var(--color-light-gray);\n  border-radius: 4px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 50px;\n}\n\n.icon-info {\n  text-align: center;\n}\n\n.icon-test-area {\n  margin-top: 30px;\n  padding: 20px;\n  background-color: var(--color-light-gray);\n  border-radius: 6px;\n}\n\n.icon-test-content {\n  margin-top: 15px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n}\n\n.icon-size-test,\n.icon-color-test {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n/* Button Test Area */\n.button-test-area {\n  margin-top: 20px;\n}\n\n.button-variants,\n.button-states,\n.button-with-icons {\n  margin-bottom: 30px;\n  padding: 20px;\n  background-color: var(--color-light-gray);\n  border-radius: 6px;\n}\n\n.button-row {\n  display: flex;\n  gap: 15px;\n  margin-top: 15px;\n  flex-wrap: wrap;\n}\n\n/* Button Group Test Area */\n.button-group-examples {\n  margin-bottom: 30px;\n  padding: 20px;\n  background-color: var(--color-light-gray);\n  border-radius: 6px;\n}\n\n.button-group-row {\n  display: flex;\n  gap: 30px;\n  margin-top: 15px;\n  flex-wrap: wrap;\n  align-items: flex-start;\n}\n\n.button-group-demo {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  min-width: 200px;\n}\n\n.button-group-demo .button-group {\n  align-self: flex-start;\n}\n\n/* Mobile responsive styles for ButtonGroup */\n@media (max-width: 768px) {\n  .button-group-row {\n    flex-direction: column;\n    gap: 20px;\n  }\n  \n  .button-group-demo {\n    min-width: auto;\n    width: 100%;\n  }\n}\n\n/* Toggle Test Area */\n.toggle-test-area {\n  margin-top: 20px;\n}\n\n.toggle-variants,\n.toggle-interactive,\n.toggle-typography {\n  margin-bottom: 30px;\n  padding: 20px;\n  background-color: var(--color-light-gray);\n  border-radius: 6px;\n}\n\n.toggle-row {\n  display: flex;\n  gap: 20px;\n  margin-top: 15px;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n/* Checkbox Test Area */\n.checkbox-test-area {\n  margin-top: 20px;\n}\n\n.checkbox-variants,\n.checkbox-interactive,\n.checkbox-typography {\n  margin-bottom: 30px;\n  padding: 20px;\n  background-color: var(--color-light-gray);\n  border-radius: 6px;\n}\n\n.checkbox-row {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  margin-top: 15px;\n}\n\n.checkbox-group-example {\n  margin-bottom: 30px;\n  padding: 20px;\n  background-color: var(--color-light-gray);\n  border-radius: 6px;\n}\n\n.checkbox-group-section {\n  margin-bottom: 25px;\n}\n\n.checkbox-group-section:last-child {\n  margin-bottom: 0;\n}\n\n/* Radio Test Area */\n.radio-test-area {\n  margin-top: 20px;\n}\n\n.radio-variants,\n.radio-interactive,\n.radio-typography,\n.radio-group-example {\n  margin-bottom: 30px;\n  padding: 20px;\n  background-color: var(--color-light-gray);\n  border-radius: 6px;\n}\n\n.radio-row {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  margin-top: 15px;\n}\n\n/* Chip Test Area */\n.chip-test-area {\n  margin-top: 20px;\n}\n\n.chip-examples,\n.chip-states,\n.chip-multi-select {\n  margin-bottom: 30px;\n  padding: 20px;\n  background-color: var(--color-light-gray);\n  border-radius: 6px;\n}\n\n.chip-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-top: 15px;\n}\n\n/* Tag Test Area */\n.tag-test-area {\n  margin-top: 20px;\n}\n\n.tag-examples,\n.tag-categories,\n.tag-ingredients,\n.tag-concerns {\n  margin-bottom: 30px;\n  padding: 20px;\n  background-color: var(--color-light-gray);\n  border-radius: 6px;\n}\n\n.tag-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-top: 15px;\n}\n\n/* IconButton Test Area */\n.iconbutton-test-area {\n  margin-top: 20px;\n}\n\n.iconbutton-variants,\n.iconbutton-sizes,\n.iconbutton-states,\n.iconbutton-examples {\n  margin-bottom: 30px;\n  padding: 20px;\n  background-color: var(--color-light-gray);\n  border-radius: 6px;\n}\n\n.iconbutton-row {\n  display: flex;\n  gap: 16px;\n  margin-top: 15px;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n/* Card Test Area */\n.card-test-area {\n  margin-top: 20px;\n}\n\n.card-examples,\n.card-variants,\n.mobile-examples {\n  margin-bottom: 40px;\n}\n\n.card-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 20px;\n  margin-top: 20px;\n}\n\n.routine-card-examples {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-top: 20px;\n  max-width: 1000px;\n}\n\n/* Mobile Preview Styles */\n.mobile-preview {\n  margin-top: 20px;\n  display: flex;\n  justify-content: center;\n}\n\n.mobile-frame {\n  width: 375px;\n  height: 600px;\n  border: 8px solid var(--surface-3);\n  border-radius: 20px;\n  background-color: var(--color-white);\n  overflow: hidden;\n  box-shadow: var(--shadow-md);\n  position: relative;\n}\n\n.mobile-frame::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 60px;\n  height: 4px;\n  background-color: var(--surface-3);\n  border-radius: 0 0 4px 4px;\n}\n\n.mobile-content {\n  padding: 20px;\n  height: 100%;\n  overflow-y: auto;\n  background-color: var(--color-light-gray);\n}\n\n.mobile-card-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 12px;\n}\n\n.mobile-routine-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n/* Force mobile styles within mobile frame */\n.mobile-frame .routine-card {\n  width: 100% !important;\n  padding: 12px !important;\n  gap: 12px !important;\n  border-radius: 8px !important;\n}\n\n.mobile-frame .routine-card-image {\n  width: 64px !important;\n  height: 64px !important;\n}\n\n.mobile-frame .routine-card-content {\n  height: auto !important;\n  justify-content: space-between !important;\n  gap: 8px !important;\n}\n\n.mobile-frame .routine-card-texts {\n  gap: 4px !important;\n}\n\n.mobile-frame .routine-card-name {\n  font-size: 14px !important;\n  line-height: 1.2 !important;\n}\n\n.mobile-frame .routine-card-company {\n  font-size: 11px !important;\n  line-height: 1.2 !important;\n}\n\n.mobile-frame .routine-card-drag-handle {\n  display: none !important;\n}\n\n/* Force mobile styles for ProductCards within mobile frame */\n.mobile-frame .product-card {\n  width: 100% !important;\n  height: auto !important;\n  padding: 12px !important;\n}\n\n.mobile-frame .product-card-image {\n  width: 64px !important;\n  height: 64px !important;\n}\n\n.mobile-frame .product-card-bottom {\n  gap: 6px !important;\n  margin-top: 6px !important;\n}\n\n.mobile-frame .product-card-content p {\n  font-size: 12px !important;\n  line-height: 1.2 !important;\n}\n\n.mobile-frame .product-card-content h3 {\n  font-size: 13px !important;\n  line-height: 1.2 !important;\n}\n\n/* Force mobile styles for tags within mobile frame */\n.mobile-frame .tag {\n  padding: 0px 6px !important;\n  border-radius: 3px !important;\n}\n\n.mobile-frame .tag .typography {\n  font-size: 12px !important;\n  line-height: 18px !important;\n}\n\n/* Responsive adjustments for mobile preview */\n@media (max-width: 768px) {\n  .mobile-frame {\n    width: 320px;\n    height: 500px;\n  }\n  \n  .mobile-content {\n    padding: 16px;\n  }\n  \n  .mobile-card-grid {\n    grid-template-columns: 1fr;\n    gap: 10px;\n  }\n}\n\n/* Popover Test Area */\n.popover-test-area {\n  margin-top: 20px;\n}\n\n.popover-examples,\n.popover-variants,\n.popover-options {\n  margin-bottom: 30px;\n  padding: 20px;\n  background-color: var(--color-light-gray);\n  border-radius: 6px;\n}\n\n.popover-edge-cases {\n  margin-bottom: 30px;\n  padding: 20px;\n  background-color: var(--color-light-gray);\n  border-radius: 6px;\n  border: 2px dashed var(--color-primary-green);\n}\n\n.popover-row {\n  display: flex;\n  gap: 20px;\n  margin-top: 15px;\n  flex-wrap: wrap;\n}\n\n.popover-demo {\n  position: relative;\n  display: inline-block;\n}\n\n/* Dialog Test Area */\n.dialog-test-area {\n  margin-top: 20px;\n}\n\n.dialog-variants {\n  margin-bottom: 30px;\n  padding: 20px;\n  background-color: var(--color-light-gray);\n  border-radius: 6px;\n}\n\n.dialog-row {\n  display: flex;\n  gap: 15px;\n  margin-top: 15px;\n  flex-wrap: wrap;\n}\n\n/* Banner Test Area */\n.banner-test-area {\n  margin-top: 20px;\n}\n\n.banner-examples,\n.banner-custom-titles,\n.banner-long-content {\n  margin-bottom: 30px;\n  padding: 20px;\n  background-color: var(--color-light-gray);\n  border-radius: 6px;\n}\n\n/* TextInput Test Area */\n.textinput-test-area {\n  margin-top: 20px;\n}\n\n.textinput-examples {\n  margin-bottom: 30px;\n  padding: 20px;\n  background-color: var(--color-light-gray);\n  border-radius: 6px;\n}\n\n.textinput-examples .text-input-container {\n  margin-bottom: 0;\n}\n\n/* Sidebar Test Area */\n.sidebar-test-area {\n  margin-top: 20px;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 30px;\n}\n\n.sidebar-examples {\n  padding: 20px;\n  background-color: var(--color-light-gray);\n  border-radius: 6px;\n}\n\n.sidebar-preview {\n  border: 1px solid var(--color-gray);\n  border-radius: 8px;\n  background-color: var(--color-white);\n  overflow: hidden;\n}\n\n.sidebar-info {\n  padding: 20px;\n  background-color: var(--color-light-gray);\n  border-radius: 6px;\n}\n\n.sidebar-features {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.sidebar-features li {\n  margin-bottom: 12px;\n  padding-left: 20px;\n  position: relative;\n}\n\n.sidebar-features li::before {\n  content: \"•\";\n  color: var(--color-primary-green);\n  font-weight: bold;\n  position: absolute;\n  left: 0;\n}\n\n/* Responsive design for sidebar test area */\n@media (max-width: 768px) {\n  .sidebar-test-area {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n}\n\n/* Interactive Tests */\n.interactive-tests {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 20px;\n  margin-top: 20px;\n}\n\n.test-card {\n  border: 1px solid var(--color-light-gray);\n  border-radius: 6px;\n  padding: 20px;\n  background-color: var(--color-white);\n}\n\n.interactive-icons,\n.interactive-buttons {\n  display: flex;\n  gap: 15px;\n  margin-top: 15px;\n  flex-wrap: wrap;\n}\n\n/* Loading Spinner Test Area */\n.loading-spinner-test-area {\n  margin-top: 20px;\n}\n\n.loading-spinner-sizes,\n.loading-spinner-with-text,\n.loading-spinner-use-cases,\n.loading-spinner-variants {\n  margin-bottom: 30px;\n  padding: 20px;\n  background-color: var(--color-light-gray);\n  border-radius: 6px;\n}\n\n.loading-spinner-row {\n  display: flex;\n  gap: 30px;\n  margin-top: 15px;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  justify-content: center;\n}\n\n.loading-spinner-demo {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 15px;\n  min-width: 150px;\n}\n\n.loading-spinner-examples {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 20px;\n  margin-top: 15px;\n}\n\n.loading-spinner-example {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 15px;\n  padding: 20px;\n  background-color: var(--color-white);\n  border-radius: 6px;\n  border: 1px solid var(--color-gray);\n}\n\n.loading-spinner-text-examples {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  margin-top: 15px;\n  align-items: center;\n}\n\n/* Responsive Test */\n.responsive-test {\n  margin-top: 20px;\n}\n\n.responsive-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 20px;\n  margin-top: 20px;\n}\n\n.responsive-item {\n  border: 1px solid var(--color-light-gray);\n  border-radius: 6px;\n  padding: 20px;\n  background-color: var(--color-light-gray);\n}\n\n/* Mobile Responsive */\n@media (max-width: 768px) {\n  .design-system {\n    padding: 16px;\n  }\n  \n  .design-system-section {\n    padding: 20px;\n    margin-bottom: 40px;\n  }\n  \n  .component-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .color-grid {\n    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));\n  }\n  \n  .icon-grid {\n    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));\n  }\n  \n  .button-row {\n    flex-direction: column;\n  }\n  \n  .interactive-tests {\n    grid-template-columns: 1fr;\n  }\n  \n  .responsive-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .card-grid {\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  }\n  \n  .routine-card-examples {\n    max-width: 100%;\n  }\n  \n  .popover-row {\n    flex-direction: column;\n    gap: 16px;\n  }\n  \n  .iconbutton-row {\n    gap: 12px;\n  }\n  \n  .loading-spinner-row {\n    flex-direction: column;\n    gap: 20px;\n  }\n  \n  .loading-spinner-examples {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 480px) {\n  .design-system {\n    padding: 16px;\n  }\n  \n  .design-system-section {\n    padding: 15px;\n  }\n  \n  .color-grid {\n    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));\n  }\n  \n  .icon-grid {\n    grid-template-columns: repeat(auto-fit, minmax(80px, 1fr));\n  }\n} "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
